import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}
  post(url, payload, options?) {
    return this.http
      .post(environment.baseURL + url, JSON.stringify(payload), options)
      .pipe(map(({ response }: any) => response));
  }
  get(url, options?) {
    return this.http
      .get(environment.baseURL + url, options)
      .pipe(map(({ response }: any) => response));
  }
  getLocation = (position) => {
    const { LOCATION_API, GOOGLE_APIKEY } = environment;
    const {
      coords: { latitude, longitude },
    } = position;

    return this.http.get(
      `${LOCATION_API + latitude},${longitude}&key=${GOOGLE_APIKEY}`
    );
  };

  filePost(url, formData, options?) {
    return this.http
      .post(environment.baseURL + url, formData, options)
      .pipe(map(({ response }: any) => response));
  }

  returnfilePost(url, formData, options?) {
    return this.http
      .post<any>(environment.baseURL + url, formData, options)
      .pipe(
        map((res: any) => {
          if (res && res.response && res.response.data) {
            return res.response; // return just the `data` object
          } else {
            console.error(
              'API response does not contain response.data property:',
              res
            );
            return null; // or throw an error
          }
        })
      );
  }
}
